import { useAvailableLanguages } from '../../../data'
import { RadixSelectField, RadixSelectFieldProps } from '../../rapid-ui'

export function CampaignLanguageSelectField(
	selectFieldProps: Omit<RadixSelectFieldProps<string>, 'options' | 'renderOption'>,
) {
	const availableLanguages = useAvailableLanguages()

	return (
		<div>
			<RadixSelectField
				label="Language"
				{...selectFieldProps}
				options={availableLanguages.map((language) => language.code)}
				renderOption={(option) => (
					<RenderOption option={availableLanguages.find((language) => language.code === option)} />
				)}
			/>
		</div>
	)
}

function RenderOption({ option }: { option?: ReturnType<typeof useAvailableLanguages>[number] }) {
	if (!option) { return null }

	return (
		<div className="flex items-center gap-2 w-full">
			<div className="w-4 h-3">
				{option.flag}
			</div>
			{option.name}
			<div className="text-[10px] text-gray-400">{option.code}</div>
		</div>
	)
}
